import { application } from "./application"

import PasswordRevealController from "./password_reveal_controller"
application.register("password-reveal", PasswordRevealController)

import DemoLoginController from "./demo_login_controller"
application.register("demo-login", DemoLoginController)

import ListboxController from "./listbox_controller"
application.register("listbox", ListboxController)

import EpisodesController from "./episodes_controller"
application.register("episodes", EpisodesController)

import DownloadsController from "./downloads_controller"
application.register("downloads", DownloadsController)

import TranscriptController from "./transcript_controller"
application.register("transcript", TranscriptController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
